// extracted by mini-css-extract-plugin
export default {"btn_error":"ClientDeleteForm_btn_error__ILLcA","btn_success":"ClientDeleteForm_btn_success__ZF7Rd"};